module.exports = __webpack_public_path__ + "static/media/dwt-11.6f7addd5.jpg";